import { C } from '../../theme.js';
import { Code, Eyebrow, FieldLabel, Pill } from '../../components/Primitives.jsx';
import { MultiCols } from '../shared/MultiCols.jsx';

// ── Cleaning ───────────────────────────────────────────────────────────
export function DropNullsInspector({ step, onChange }) {
  const c = step.config || {};
  const sel = c.columns || [];
  return (
    <div>
      <Eyebrow>Drop rows where these columns are blank</Eyebrow>
      <div style={{ color: C.fg4, fontSize: '.78rem', margin: '4px 0 10px', lineHeight: 1.5 }}>
        A row is dropped if <em>any</em> of the selected columns is empty,
        <Code>N/A</Code> or <Code>—</Code>. With no columns selected, rows are
        dropped only if every column is blank.
      </div>
      <MultiCols selected={sel} onChange={(v) => onChange({ ...step, config: { ...c, columns: v } })} />
      <FieldLabel hint="Defines what counts as blank">Blank values</FieldLabel>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {['', 'N/A', '—', 'null', 'NaN'].map(v => (
          <Pill key={v} tone="ghost">{v === '' ? '""' : v}</Pill>
        ))}
      </div>
    </div>
  );
}
